<template>
    <div class="max-w-sm px-20">
        <h2 class="auth-title mb-10">{{ $t('auth.login.title') }}</h2>
        <div v-if="showForm">
            <!-- <div id="firebaseui-auth-container" @click="alert('click')" lang="es"></div>

            <div class="flex items-center my-10">
                <hr class="w-3/4">
                <p class="mx-3 text-xs">o</p>
                <hr class="w-3/4">
            </div> -->

            <social-login @loggedIn="login" @startRegister="openRegister"/>

            <form>
                <div>
                    <ria-input 
                        name="email" 
                        :label="$t('auth.login.email_or_username')" 
                        validation="required" 
                        type="email" 
                        class="mb-8"
                        value="" 
                        ref="email" />

                    <ria-input 
                        name="password" 
                        :label="$t('auth.login.password')" 
                        validation="required" 
                        type="password" 
                        class="mb-10"
                        value="" 
                        autocomplete="current-password"
                        ref="password" />

                    <ria-button type="button" class="block mx-auto mt-4 text-base" :fullwidth="true" :text="$t('auth.login.login')" :action="customLogin"/>

                    <div class="password-forget" @click="restorePassword">
                        {{ $t('auth.login.password_forget') }}
                    </div>

                    <a class="mt-5 text-xs" @click="openRegister">{{ $t('auth.login.register') }}</a>
                </div>
            </form>
        </div>
        <div v-if="!showForm">
            {{ $t('auth.login.success') }}
            <ria-button type="button" class="block mx-auto mt-4 text-base" :fullwidth="true" text="Close" :action="closeModal"/>
        </div>
    </div>
</template>

<script>
    import TokenManager from "@/api/tokenManager/TokenManager"
    import RiaButton from "@/components/common/ria-button"
    import RiaInput from "@/components/form/elements/ria-input";
    import SocialLogin from "@/components/auth/social-login";
    import {apiClient} from "@/api"; 
    import i18n from '@/i18n';

    export default {
        name: "login",
        components : {
            RiaButton,
            RiaInput,
            SocialLogin,
        },
        data: function() {
            return {
                firebase: null,
                showForm: true
            }
        },
        methods: {
            customLogin() {
                const usernameOrEmail = this.$refs.email.value;
                const password = this.$refs.password.value;

                apiClient.skitudeLogin(usernameOrEmail, password).then((response) => {
                    return this.firebaseCustomLogin(response.data.object.jwt).then(() => {
                        this.showForm = false
                    });
                }).catch((error) => {
                    console.error(`Error logging in user to Firebase: ${error.message}`);
                    
                    const messageKey = error.response.status == 403 ? 'auth.login.invalid_credentials' : 'auth.login.error';
                    const event = new CustomEvent('errorModal', {
                        detail: {
                            body: i18n.t(messageKey)
                        } 
                    });
                    window.dispatchEvent(event)
                })
            },
            login() {
                this.showForm = false
                this.$emit('loggedIn')
            },
            restorePassword() {
                this.$emit('restorePassword')
            },
            closeModal() {
                this.$emit('closeAllModals')
            },
            openRegister() {
                this.$emit('openRegister')
            },
            firebaseCustomLogin(jwt) {
                return this.firebase.auth().signInWithCustomToken(jwt)
            },
        },
        mounted () {
            let tokenManager = new TokenManager()
            this.firebase = tokenManager.getFirebaseSDK()
        }
    };
</script>

<style scoped>
    .password-forget {
        @apply mt-4.5 text-center cursor-pointer text-secondary;
    }
    
    a {
      @apply block cursor-pointer text-center text-sm
    }
</style>

